export default {
  title: "Registration",
  welcomeTitle: "Welcome to Prodgy",
  welcomeDescription: "Complete your registration to access the platform",
  formFields: {
    password: "Password",
    confirmPassword: "Confirm Password",
    passwordPlaceholder: "Enter your password",
    confirmPasswordPlaceholder: "Confirm your password",
  },
  validation: {
    passwordMinLength: "Password must be at least 8 characters long",
    passwordRequirements: "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    passwordsMustMatch: "Passwords must match",
  },
  userInfo: {
    title: "Your Information",
    name: "Name",
    email: "Email",
    role: "Role",
    roleAdmin: "Administrator",
    roleUser: "User",
  },
  buttons: {
    createAccount: "Get Started",
    creatingAccount: "Processing...",
    goToLogin: "Go to login page",
  },
  errors: {
    invalidInvite: "Invalid invitation. Please check the link you received.",
    expiredInvite: "This invitation is not valid or has expired.",
    validationError: "Error validating invitation. Please try again or contact support.",
    registrationError: "An error occurred while registering your account. Please try again.",
    passwordSetupFailed: "Error setting up password.",
    autoLoginFailed: "Error with automatic login:",
    registrationProcessError: "Error finalizing registration:",
    tokenUsed: "This invitation link has already been used or has been cancelled.",
    contactAdmin: "If you need assistance, please contact the system administrator.",
    title: "Error",
    validationTitle: "Could not validate your invitation",
    expiredTitle: "Link Expired",
    expiredDescription: "The invitation link is no longer valid",
    usedTitle: "Link Already Used",
    usedDescription: "This invitation link has already been used",
    invalidTitle: "Invalid Link",
    invalidDescription: "The invitation link is not valid",
    PASSWORD_TOO_LONG: "Password cannot be longer than 72 characters.",
    DEFAULT: "Error setting up password.",
    passwordErrorTitle: "Password Error",
  },
  success: {
    title: "Password Set!",
    description: "Your account has been set up successfully",
    message: "You will be redirected automatically to Prodgy...",
  },
  passwordRequirements: {
    title: "Password Requirements",
    minChars: "Minimum of 8 characters",
    upperCase: "At least one uppercase letter (A-Z)",
    lowerCase: "At least one lowercase letter (a-z)",
    number: "At least one number (0-9)",
    specialChar: "At least one special character (!@#$...)",
    match: "Passwords must match",
  },
  agreeTermsStart: "By completing the registration, you agree to the ",
  agreeTermsMiddle: "and",
  agreeTermsEnd: ".",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  checking: "Checking your invitation...",
  redirecting: "Redirecting to home page...",
  pleaseWait: "Please wait a moment.",
  common: {
    poweredBy: "Powered by",
    companyName: "Programmers",
    trademark: "®",
    appName: "Prodgy",
    error: "Error",
    success: "Success",
    errorClearingSession: "Error clearing session, continuing anyway:"
  },
  resetPassword: {
    title: "Reset Password",
    description: "Enter your new password below",
    validatingToken: "Validating your reset link...",
    invalidToken: "Invalid Reset Link",
    tokenExpiredOrInvalid: "The password reset link is invalid or has expired",
    requestNewLink: "Please request a new password reset link",
    backToLogin: "Back to login",
    successTitle: "Password Reset Successful!",
    successDetail: "Your password has been reset successfully",
    redirecting: "You will be redirected to the login page shortly...",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    requirements: "Password Requirements",
    reqMinLength: "Minimum 8 characters",
    reqUppercase: "At least one uppercase letter",
    reqLowercase: "At least one lowercase letter",
    reqNumber: "At least one number",
    reqSpecial: "At least one special character",
    processing: "Processing...",
    submit: "Reset Password",
    genericError: "An error occurred while resetting your password",
    invalidRequest: "Invalid reset request",
    successMessage: "Password has been successfully reset",
    errorResetting: "Error resetting password:",
    sessionCleared: "Session cleared silently for password reset process"
  }
} as const;
